import {useRef} from "react";
import {Web} from "sip.js";

const useSip = (audio) => {
    const options = {
        media: {
            remote: {
                audio: audio.remote.current
            },
            local: {
                audio: audio.local.current
            }
        },
        userAgentOptions: {
            logBuiltinEnabled: false
        }
    };
    const instance = useRef(null);
    if (instance.current === null) {
        instance.current = new Web.SimpleUser(`wss://${process.env.REACT_APP_WSS_URL}`, options);
    }
    return instance.current
};

export default useSip;